import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import { showLenderSettingsAPI, createOrUpdateLenderSettingsAPI } from './asyncActions'

const lenderSettingsSlice = createSlice({
  name: 'lenderSettings',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [showLenderSettingsAPI.pending](state) {
      state.uiFlags.isFetching = true
    },
    [showLenderSettingsAPI.fulfilled](state, action) {
      state.uiFlags.isFetching = false
      state.stagedRecord = action.payload
    },
    [showLenderSettingsAPI.rejected](state) {
      state.uiFlags.isFetching = false
    },
    [createOrUpdateLenderSettingsAPI.pending](state) {
      state.uiFlags.isCreating = true
    },
    [createOrUpdateLenderSettingsAPI.fulfilled](state, action) {
      state.uiFlags.isCreating = false
      state.stagedRecord = action.payload
    },
    [createOrUpdateLenderSettingsAPI.rejected](state) {
      state.uiFlags.isCreating = false
    },
  },
})

export default lenderSettingsSlice
